import { getObjectUtil } from 'packages/src'

function getMessageErrorUtil (error, defaultMessage) {
  if (typeof error === 'string') {
    return error
  }
  return getObjectUtil(error, 'message') || defaultMessage || 'An error occurred'
}

export default getMessageErrorUtil
